import React, { Fragment, useEffect, useState } from "react";
import Swal from "sweetalert2";

import SideNav from "../../Components/SideNav";
import FormularioAgregar from "../../Components/FormularioAgregar";
import FormularioEditar from "../../Components/FormularioEditar";
import View from "./View";

import { useAuth } from "../../Context/Context";

import AutoresBlogsHelper from "../../Helpers/AutoresBlogs";
import useStorage from "../../Hooks/useStorage";

const AutoresBlogs = () => {
  const { editar, setEditar } = useAuth();
  const [file, setFile] = useState({});
  const [urlAutor, setUrlAutor] = useState("");

  const [imagen, setImagen] = useState("");
  const [autores, setAutor] = useState({
    nombre: "",
    certificado: "",
    imagen: "",
  });

  // uso de hooks para agregar imagen a google storage
  const [consulta, setConsulta] = useState("");
  let [response] = useStorage(consulta);

  useEffect(() => {
    if (!response) {
      setAutor(editar);
    } else {
      if (response.action === "agregar") {
        agregarAutor(response.url);
      } else if (response.action === "actualizar") {
        subirArchivoActualizado(autores);
      } else if (response.action === "agregarActualizado") {
        actualizarAutor(response.url, autores);
      } else {
        // error
      }
    }
  }, [editar, response]);

  const leerDato = (e) => {
    setAutor({
      ...autores,
      [e.target.name]: e.target.value,
    });
  };

  const agregarAutor = (url) => {
    autores.imagen = url;

    AutoresBlogsHelper.agregarAutor(autores);
  };

  const actualizarAutor = (url, autores) => {
    if (url !== "") {
      autores.imagen = url;
    }

    AutoresBlogsHelper.editarAutor(autores, autores._id);
  };

  const actualizarFoto = (e) => {
    setFile(e.target.files[0]);

    let fileReader = new FileReader();
    fileReader.addEventListener("load", (evt) => {
      setImagen(fileReader.result);
    });
    fileReader.readAsDataURL(e.target.files[0]);
  };

  const actualizarFotoEditar = (e) => {
    setFile(e.target.files[0]);
    setUrlAutor(autores.imagen);

    let fileReader = new FileReader();
    fileReader.addEventListener("load", (evt) => {
      setEditar({
        ...editar,
        [e.target.name]: fileReader.result,
      });
    });
    fileReader.readAsDataURL(e.target.files[0]);
  };

  const subirArchivo = (e) => {
    e.preventDefault();

    setConsulta({
      consulta: "agregar",
      name: autores.nombre,
      folder: "autores_blogs/",
      file,
      url: "/autores-blogs",
    });
  };

  const actualizarArchivo = (e) => {
    e.preventDefault();

    if (urlAutor !== "") {
      setConsulta({
        consulta: "actualizar",
        url: "/autores-cursos",
        urlFile: urlAutor,
      });
    } else {
      Swal.fire({
        icon: "question",
        title: "¿Esta seguro que desea modificar el autor?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Si",
        denyButtonText: `No`,
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          actualizarAutor("", autores);
        } else if (result.isDenied) {
          Swal.fire(
            "Modificación cancelada",
            "El campo quedo intacto",
            "succes"
          );
        }
      });
    }
  };

  const subirArchivoActualizado = (autores) => {
    setConsulta({
      consulta: "agregarActualizado",
      name: autores.nombre,
      folder: "autores_blogs/",
      file,
    });
  };

  return (
    <Fragment>
      <SideNav />
      <div className="row">
        <FormularioAgregar>
          <p className="titulo_1_admin">Información autor</p>

          <form onSubmit={subirArchivo}>
            <div className="input-field">
              <input
                onChange={leerDato}
                id="nombre"
                name="nombre"
                type="text"
                className="validate"
              />
              <label for="nombre">Nombre del autor</label>
            </div>

            <div className="input-field">
              <input
                onChange={leerDato}
                id="certificado"
                name="certificado"
                type="text"
                className="validate"
              />
              <label for="certificado">Certificado del autor</label>
            </div>

            <p>Imagen</p>
            <img alt="imagen subida" width="100%" src={imagen}></img>
            <div class="file-field input-field">
              <div class="btn">
                <span>File</span>
                <input
                  name="imagen"
                  onChange={actualizarFoto}
                  type="file"
                  required
                />
              </div>
              <div class="file-path-wrapper">
                <input
                  name="imagen"
                  class="file-path validate"
                  type="text"
                  placeholder="Upload one or more files"
                  required
                />
              </div>
            </div>

            <div className="botonn_1_admin" style={{ marginTop: "10px" }}>
              <button type="submit">Agregar autor</button>
            </div>
          </form>
        </FormularioAgregar>
        <FormularioEditar>
          <p className="titulo_1_admin">Editar autor</p>
          <form onSubmit={actualizarArchivo}>
            <div className="input-field">
              <input
                onChange={leerDato}
                defaultValue={editar.nombre}
                id="nombre"
                name="nombre"
                type="text"
                className="validate"
              />
              <label className="active" for="nombre">
                Nombre del autor
              </label>
            </div>

            <div className="input-field">
              <input
                onChange={leerDato}
                defaultValue={editar.certificado}
                id="certificado"
                name="certificado"
                type="text"
                className="validate"
              />
              <label className="active" for="certificado">
                Nombre del autor
              </label>
            </div>

            <img alt="imagen subida" width="100%" src={editar.imagen}></img>
            <div class="file-field input-field">
              <div class="btn">
                <span>File</span>
                <input
                  name="imagen"
                  onChange={actualizarFotoEditar}
                  type="file"
                />
              </div>
              <div class="file-path-wrapper">
                <input
                  name="imagen"
                  class="file-path validate"
                  type="text"
                  placeholder="Upload one or more files"
                />
              </div>
            </div>

            <div className="botonn_1_admin" style={{ marginTop: "10px" }}>
              <button type="submit">Actualizar autor</button>
            </div>
          </form>
        </FormularioEditar>
        <View />
      </div>
    </Fragment>
  );
};

export default AutoresBlogs;
